import { VARIANTS } from '../constants'

export const isOutline = (variant) => {
  return variant === VARIANTS.OUTLINE
}
